import { render, staticRenderFns } from "./Sect.vue?vue&type=template&id=f7c8defc&scoped=true&"
import script from "./Sect.vue?vue&type=script&lang=js&"
export * from "./Sect.vue?vue&type=script&lang=js&"
import style0 from "./Sect.vue?vue&type=style&index=0&id=f7c8defc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c8defc",
  null
  
)

export default component.exports